import { FC } from 'react';

import {
  Typography,
  IconButton
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';

import styles from './styles.module.scss';

interface Props {
  refetch: () => void;
}

export const Error: FC<Props> = ({ refetch }) => (
  <div className={styles.error}>
    <Typography variant='body3' className={styles.label}>
      Категории не загрузились
    </Typography>
    <IconButton iconName={Icons.Refresh} size='medium' onClick={refetch}/>
  </div>
);
